import { graphql, useStaticQuery } from "gatsby";
import React, { useState } from "react";

const CategoriesDropdown = () => {
  const [clicked, setClicked] = useState(false);
  const handleClick = () => {
    setClicked(!clicked);
  };

  const data = useStaticQuery(graphql`
    query {
      allWpCategory {
        nodes {
          id
          name
        }
      }
    }
  `);

  return (
    <div className="py-thin group">
      <button onClick={handleClick}>
        Categories <span>↓</span>
      </button>
      <ul
        className={`pl-4 text-[16px] text-[#97989F] transition-all duration-300 ease-in-out overflow-hidden ${
          clicked ? "max-h-[500px]" : "max-h-0"
        }`}
      >
        {data?.allWpCategory.nodes.map((item, index) => (
          <li key={index} className={`${index === 0 && "mt-4"}`}>
            {item.name}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CategoriesDropdown;
